<template>
  <div id="app" class="container-fluid p-0" :class="theme">
    <NavbarComponent
      :isAuthenticated="isUserAuthenticated"
      :isGuest="isGuestUser"
    />
    <div>
      <router-view />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, computed } from "vue";
import NavbarComponent from "./components/NavbarComponent.vue";
import { useRoute } from "vue-router";
import { useI18n } from "vue-i18n";

export default defineComponent({
  name: "App",
  components: {
    NavbarComponent,
  },
  setup() {
    const { t } = useI18n();
    const route = useRoute();
    const isGuestUser = ref(false);

    // --- THEME SELECTION ---
    // Change this value to 'theme-AGS' to switch to the AGS theme.
    const defaultTheme = 'theme-AGS';
    const theme = ref(defaultTheme);
    // -----------------------

    // Handle guest login
    const handleGuestLogin = () => {
      isGuestUser.value = true;
    };

    // Compute authentication state based on route and guest status
    const isUserAuthenticated = computed(() => {
      // Check if user is on login page
      if (route.path === "/login") return false;

      // If user accessed as guest, they're not authenticated
      if (isGuestUser.value) return false;

      // For all other routes, consider user authenticated
      return true;
    });

    return {
      isUserAuthenticated,
      isGuestUser,
      handleGuestLogin,
      theme,
    };
  },
});
</script>

<style>
#app {
  min-height: 100vh;
  font-family: var(--font-family);
}

/* Global font styles */
* {
  font-family: var(--font-family);
}

/* Default font weights */
h1,
h2,
h3,
h4,
h5,
h6 {
  font-weight: 600;
}

button,
.btn {
  font-weight: 500;
}

body {
  font-weight: 400;
}
</style>
